module.exports = __webpack_public_path__ + "img/12-lokal-u-caipla.2eba9430.jpg";